exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".migrator__wrapper[data-v-31fc54af] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  flex-direction: column;\n}\n.migrator__wrapper > div[data-v-31fc54af] {\n  max-width: 500px;\n  font-size: 20px;\n}\n.content-header[data-v-31fc54af] {\n  display: none;\n}", ""]);

// exports
